<script>
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let showSpinner = false;
	export let showTimes = false;
	export let showDropUp = false;
    export let showSearch = false;

	let classes = 'icon grey';
	let viewBox = '0 0 320 512';
	let pathD = 'M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z';

	$: {
		if (showSpinner) {
			classes = 'icon spinner black';
			viewBox = '0 0 512 512';
			pathD = 'M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z';
		} else if (showTimes) {
			classes = 'icon grey';
			viewBox = '0 0 340 512';
			pathD = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';
		} else if (showDropUp) {
			classes = 'icon black';
			viewBox = '0 0 320 512';
			pathD = 'M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z';
		} else if (showSearch) {
			classes = 'icon search black';
			viewBox = '0 0 16 16';
			pathD = 'M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z';
		} else {
			classes = 'icon grey';
			viewBox = '0 0 320 512';
			pathD = 'M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z';
		}
	}

	let handleClick = event => dispatch('click');
</script>

<div class={classes}>
	<svg width='100%' height='100%' viewBox={viewBox} on:click={handleClick}>
		<path d={pathD}/>
	</svg>
</div>

<style>
	.icon {
		flex: 0 0 30px;
		height: 39px;
		padding: 0 10px;
		background: #fff;
	}

	.grey path {
		fill: #c5cacf;
	}

	.grey:hover path {
		fill: rgba(0, 0, 0, 0.6);
	}

	.black path {
		fill: #000;
	}

	.spinner {
		color: #51ce6c;
		animation: rotate 0.75s linear infinite;
	}

    .search {
		padding: 0 5px;
        height: 30px;
	}
</style>
